interface ClusterInterface {
    CLUSTER_NAME: string;
    API_URL: string,
    JENKINS_BUILD_URL: string,
    JENKINS_DEPLOY_URL: string
}

const JENKINS_BUILD_URL = window['JENKINS_BUILD_URL']
const JENKINS_DEPLOY_URL = window['JENKINS_DEPLOY_URL']
const AUTHORITY = window['AUTHORITY']
const CLIENT_ID = window['CLIENT_ID']
const CLUSTER = window['CLUSTER']
const CLUSTERS: Map<string, ClusterInterface> = window['CLUSTERS']
const GRANULAR = window['ENABLE_GRANULAR_ENDPOINT'] === true
const AUDIT = window['ENABLE_AUDIT'] === true
const ENABLE_ALERTS = window['ENABLE_ALERTS'] === true
const SECRET_MANAGER_INSTANCES = window['SECRET_MANAGER_INSTANCES']
const NEW_DOMAIN = window['NEW_DOMAIN'];
// routes/front.ts renders unset env vars as the literal string "undefined", which
// is not nullish — so only trust an absolute URL here and default to this origin.
const RAW_BACKEND_API_URL = window['BACKEND_API_URL'];
const BACKEND_API_URL = /^https?:\/\//i.test(RAW_BACKEND_API_URL ?? '')
    ? RAW_BACKEND_API_URL
    : window.location.origin;

export {
    JENKINS_BUILD_URL,
    JENKINS_DEPLOY_URL,
    AUTHORITY,
    CLIENT_ID,
    CLUSTER,
    CLUSTERS,
    GRANULAR,
    AUDIT,
    ENABLE_ALERTS,
    SECRET_MANAGER_INSTANCES,
    BACKEND_API_URL,
    NEW_DOMAIN
}